import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { BASE_URL } from "../../../src/config.json";
import { NavLink } from "react-router-dom";

const initialValues = {
  email: "",
  consent: false,
};

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Must be a valid email")
    .required("Email is required."),
  consent: yup.boolean().oneOf([true], "Please check this box"),
});

const NewsLetter = () => {
  const handleSubmit = async (values, { resetForm }) => {
    try {
      await axios.post(`${BASE_URL}/newsletter/subscribe`, {
        email: values.email,
      });
      toast.success("Subscribed to newsletter");
      resetForm();
    } catch (error) {
      toast.error("Error while subscribing to newsletter");
    }
  };

  return (
    <div className="footer">
      <ToastContainer />
      <div className="page-width">
        <div className="footer-social">
          <div>
            <h2 className="footer__nav-title">GET SOCIAL</h2>
            <ul className="social_media">
              {["facebook", "twitter", "instagram", "youtube"].map(
                (platform) => (
                  <li className="social_media__nav__link" key={platform}>
                    <a
                      href={`https://www.${platform}.com/`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="copyright__nav__link-item"
                    >
                      <img
                        src={
                          require(`../../assets/images/footer/${platform}.svg`)
                            .default
                        }
                        alt={`${platform} icon`}
                      />
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>
      
            <ul >
              {["/for-player", "/for-club", "/about", "/contact"].map((path, index) => (
                <li className="header__nav__item" key={index}>
                  <NavLink
                    to={path}
                    className="header__nav__item-link"
                  >
                    {path.split("/")[1].toUpperCase().replace("-", " ")}
                  </NavLink>
                </li>
              ))}
            </ul>
    
          <div className="footer__newsletter">
            <div className="footer__nav-title">Get Newsletter Updates</div>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="footer__nav__sign">
                  <div className="footer__nav__sign newsletter">
                    <Field
                      type="email"
                      name="email"
                      placeholder="Email address"
                      className="footer__nav__sign-email"
                    />
                    <button
                      type="submit"
                      className="footer__nav__sign-btn"
                      disabled={isSubmitting}
                    >
                      SIGN UP
                    </button>
                  </div>

                  <div className="footer__nav-check">
                    <Field
                      type="checkbox"
                      id="consent"
                      name="consent"
                      className="checkbox-input"
                    />
                    <label htmlFor="consent" className="checkmark_ft"></label>
                    <span>I CONSENT TO RECEIVING MARKETING COMMUNICATIONS</span>
                  </div>

                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error-mail"
                    style={{ color: "red" }}
                  />
                  <ErrorMessage
                    name="consent"
                    component="div"
                    className="error-mail"
                    style={{ color: "red" }}
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsLetter;
